<template>
  <div class="vue-create-town-wrap">
    <div class="controls-container-wrapper">
      <div class="selected-utility-container">
        <!-- name -->
        <div class="controls-container">
          <div class="control">
            <label for="utility">Name:</label>
            <input v-model="newTown.name" placeholder="Town name" type="text" class="name" v-bind:disabled="creatingTown">
          </div>
        </div>
        <!-- code -->
        <div class="controls-container">
          <div class="control">
            <label for="utility">Code:</label>
            <input v-model="newTown.code" placeholder="Town code" type="text" class="code" v-bind:disabled="creatingTown">
          </div>
        </div>
      <!-- county -->
      <div class="controls-container selected-utility">
        <div class="control utility-description">
          <label for="utility">County:</label>
          <select v-model="newTown.countyId" @change="onCountySelectChange($event)" name="utilites">
          <option v-for="county in counties" :key="county.countyId" :value="county.countyId">{{county.name}}</option>
          </select>
        </div>
      </div>
      </div>
    </div>
    <div class="create-town-footer">
      <b-spinner v-if="creatingTown" class="ajax-spinner"></b-spinner>
      <template v-if="!creatingTown">
      <b-button class="cancel" @click="cancel" v-bind:disabled="creatingTown">Cancel</b-button>
      <b-button class="submit"  @click="createTown" v-bind:disabled="creatingTown || !newTown.name || !newTown.code || !newTown.countyId">Create Town</b-button>
      </template>
    </div>
  </div>
</template>

<script>
import API from "@/services/api";
import lodash from 'lodash';

export default {
  name: 'CreateTownForm',
  props: {
    hide: Function,
    counties: Array,
    createTownSuccess: Function
  },
  data() {
    return {
      newTown: {},
      creatingTown: undefined,
      fadeErrorMessage: undefined,
      createTownErrorMessage: undefined
    }
  },
  methods: {
      cancel() {
        this.hide();
      },
      onCountySelectChange(event) {
        const matchinCounty = lodash.find(this.counties, county => county.countyId === parseInt(event.target.value));
        this.selectedCounty = matchinCounty ? matchinCounty : undefined;

        if (this.matchinCounty) {
          this.newTown.countyId = this.matchinCounty.countyId;
        }
      },
      createTown() {
        this.creatingTown = true;

        const postData = {
          name: this.newTown.name,
          code: this.newTown.code,
          countyId: this.newTown.countyId
        };

        try {
          API.CreateTown(postData).then(() => {
            this.creatingTown = false;
            this.createTownSuccess();
          }, err => {
            console.error('CreateTown - ERROR');
            console.dir(err);
            this.creatingTown = false;

            if (err
            && err.response
            && err.response.data) {
              this.createTownErrorMessage = err.response.data;
            } else {
                this.createTownErrorMessage = `Error creating town ${this.newTown.name}`;
            }

            setTimeout(() => {this.fadeErrorMessage = true}, 3000);
            setTimeout(() => {
              this.createTownErrorMessage = '';
              this.fadeErrorMessage = false;
            }, 6000);
          })
        } catch (err) {
            this.updatingTown = false;
            console.error('CreateTown - catch - ERROR!');
            console.dir(err);
        }
      }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../../assets/css/partials/_variables.scss";

.ajax-spinner{
  position: relative;
  top: 14px;
  right: 10px;
  height: 40px;
  width: 40px;
  font-size: 22px;
  color: #fbd850;
}

.error-message{
  display: block;
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: bold;
  color: #800000;
  -webkit-transition: all 2s ease-in-out;
  -moz-transition: all 2s ease-in-out;
  -o-transition: all 2s ease-in-out;
  transition: all 2s ease-in-out;

  &.fade {
      opacity: 0;
  }
}

.controls-container-wrapper{
  .controls-container {
    width: 80%;
    margin-bottom: 20px;
    padding: 10px;
    background-color: $modalGrey;

    input[type="text"] {
      width: 100%;
      height: 40px;
      padding-left: 10px;
      border: none;
    }

    label {
      margin-right: 10px;
      font-weight: bold;
    }

    input[type="text"] {
      width: 100%;
    }

    h4{
      font-size: 18px;
      font-weight: bold;
    }
  }
}

.create-town-footer{
  .btn{
    margin-right: 10px;

    &:last-child{
      margin-right: 0;
    }
  }
}
</style>
